import { Component } from '@angular/core';
import { HeaderComponent } from '../../shared/header/header.component';
import { FooterComponent } from '../../shared/footer/footer.component';

@Component({
  selector: 'app-aviso-privacidad',
  imports: [HeaderComponent, FooterComponent],
  templateUrl: './aviso-privacidad.component.html',
  styleUrl: './aviso-privacidad.component.scss'
})
export class AvisoPrivacidadComponent {
footerColorClass = 'footer-promotor';
}
